<mat-card fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
  <mat-card-header
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="10px"
  >
    <div
      fxLayout="row nowrap"
      fxLayoutAlign="space-between center"
      fxLayoutGap="10px"
    >
      <menu-header [menuTopic]="menuTopic"></menu-header>

      <button
        *ngIf="showCreateButton"
        mat-flat-button
        color="primary"
        (click)="openCreateModal()"
      >
        <mat-icon>add</mat-icon>
        {{ "view_value.create_meter" | translate }}
      </button>
    </div>
    <mat-divider></mat-divider>
  </mat-card-header>

  <mat-card-content
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="10px"
  >
    <div
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="start stretch"
      fxLayoutAlign.gt-sm="space-between center"
      fxLayoutGap.gt-sm="10px"
      style="padding-top: 16px"
    >
      <div fxLayout="row" fxLayoutAlign="center center" style="gap: 16px">
        <mat-menu #columnMenu="matMenu">
          <div
            cdkDropList
            (cdkDropListDropped)="dropColumn($event)"
            class="column-config"
            (click)="$event.stopPropagation()"
          >
            <div
              *ngFor="let col of columnState; trackBy: trackColumn"
              cdkDrag
              class="column-item"
            >
              <mat-checkbox
                [checked]="col.visible"
                (change)="toggleColumn(col.key)"
                (click)="$event.stopPropagation()"
                class="checkbox-primary"
              >
                {{ col.label | translate }}
              </mat-checkbox>

              <mat-icon cdkDragHandle>drag_indicator</mat-icon>
            </div>
          </div>
        </mat-menu>
        <mat-form-field fxFlex="200px" appearance="outline" *ngIf="showSearch">
          <mat-label>{{ "view_value.search" | translate }}</mat-label>
          <input
            matInput
            [(ngModel)]="searchGroupMeter"
            (keyup.enter)="search()"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-form-field
          fxFlex="200px"
          appearance="outline"
          *ngIf="showFilterFloor"
        >
          <mat-label>
            {{ "view_value.select" | translate }}
            {{ "view_value.location_tier_3" | translate }}
          </mat-label>

          <input
            matInput
            [formControl]="floorControl"
            [matAutocomplete]="autoFloor"
          />

          <mat-autocomplete
            #autoFloor="matAutocomplete"
            [displayWith]="displayStr"
            (optionSelected)="onSelectFloor($event.option.value)"
          >
            <mat-option value="all">
              {{ "view_value.all" | translate }}
            </mat-option>

            <mat-option *ngFor="let floor of filteredFloorList" [value]="floor">
              {{ floor | translate }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field
          fxFlex="200px"
          appearance="outline"
          *ngIf="showFilterGroup"
        >
          <mat-label>
            {{ "view_value.select" | translate }}
            {{ "view_value.tag" | translate }}
          </mat-label>

          <input
            matInput
            [formControl]="groupControl"
            [matAutocomplete]="autoGroup"
          />

          <mat-autocomplete
            #autoGroup="matAutocomplete"
            [displayWith]="displayStr"
            (optionSelected)="onSelectGroup($event.option.value)"
          >
            <mat-option value="all">
              {{ "view_value.all" | translate }}
            </mat-option>

            <mat-option *ngFor="let group of filteredGroupList" [value]="group">
              {{ group }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="showFilterType">
          <mat-label>{{ "view_value.sensor_type" | translate }}</mat-label>
          <mat-select [(ngModel)]="sensorType">
            <mat-option *ngFor="let item of sensor_type_list" [value]="item">
              {{ item | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-flat-button
          class="btn-outline"
          type="button"
          (click)="reset()"
        >
          <mat-icon>history</mat-icon>
          {{ "view_value.reset" | translate }}
        </button>

        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="search()"
        >
          <mat-icon>search</mat-icon>
          {{ "view_value.search" | translate }}
        </button>
      </div>
      <div class="manage">
        <button
          *ngIf="showExportButton"
          mat-flat-button
          color="primary"
          (click)="onExportCSV()"
        >
          <mat-icon style="color: white !important">save_alt</mat-icon>
          Export
        </button>
        <button
          mat-flat-button
          class="btn-outline"
          [matMenuTriggerFor]="columnMenu"
        >
          <mat-icon>settings</mat-icon>
          <p>{{ "view_value.customize_column" | translate }}</p>
        </button>
      </div>
    </div>

    <div style="width: 100%; overflow: auto">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container
          *ngFor="let column of columns; trackBy: trackColumn"
          [matColumnDef]="column.key"
        >
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            [disabled]="!column.sortable"
            [class]="column.widthClass || ''"
          >
            {{ column.label | translate }}
          </th>

          <td mat-cell *matCellDef="let element; let i = index">
            <ng-container [ngSwitch]="column.type">
              <ng-container *ngSwitchCase="'number'">
                {{
                  getNumberCellValue(element, column, i)
                    | number: getDecimalInfo(column)
                }}
              </ng-container>

              <ng-container *ngSwitchCase="'datetime'">
                {{
                  getDateCellValue(element, column, i)
                    | date: "dd/MM/yyyy HH:mm:ss"
                }}
              </ng-container>

              <ng-container *ngSwitchCase="'status'">
                <span
                  [ngClass]="
                    getStatusClass(getStatusCellValue(element, column, i))
                  "
                >
                  {{ getStatusCellValue(element, column, i) }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'action'">
                <!-- Primary Action -->

                <div class="action-cell">
                  <button
                    mat-icon-button
                    (click)="openDetailModal(element)"
                    matTooltip="View"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>

                  <!-- Overflow -->
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button
                      mat-menu-item
                      (click)="openDetailModal(element, true)"
                    >
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                    </button>

                    <mat-divider></mat-divider>

                    <!-- <button mat-menu-item (click)="onDelete(row)">
                    <mat-icon color="warn">delete</mat-icon>
                    <span class="warn">Delete</span>
                  </button> -->
                  </mat-menu>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                {{ getCellValue(element, column, i) }}
              </ng-container>
            </ng-container>
          </td>
        </ng-container>

        <tr class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            <div class="no-data-container">
              <mat-icon class="no-data-icon">inbox</mat-icon>
              <p>{{ "view_value.no_data" | translate }}</p>
            </div>
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
